import * as React from 'react';
import { cn } from '@/lib/utils';

const Separator = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn('shrink-0 bg-border h-[1px] w-full', className)} {...props} />
);

export { Separator };
